export const SelectMenuItemVariant = {
  ITEM: 'item',
  GROUP: 'group'
};